import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-menschmikrobe',
  templateUrl: './menschmikrobe.component.html',
  styleUrls: ['./menschmikrobe.component.scss']
})
export class MenschmikrobeComponent implements OnInit {

  exposition: CardContent = {
    title: 'MenschMikrobe',
    subtitle: 'Interactive exhibit for a science exhibition',
    image_source: 'assets/images/MM-Exhibit.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Partners</h4>k-Project, RKI, dfg',
      '<h4>Methods</h4>Interactive Visualisation',
      '<h4>Technology / Skills</h4>Java, Swing',
      '<h4>Term</h4>2009-2014',
    ]
  };

  exhibition: CardContent = {
    title: 'Touch Display Exhibit',
    image_source: 'assets/images/MM-Presse_17small.jpg',
  }

  objective: CardContent = {
    title: 'Objective',
    sections: [
      `In 2009 the German Robert Koch Institute mandated us to prepare an
      epidemic simulator for their „MenschMikrobe“ exhibition. We already
      had developed an individual based influenza simulator that helped
      public health authorities to make their contingency plans for the
      next pandemic. This simulator though was too complex for an exhibition
      addressed to the general public. After all it has more than fifty
      parameters that can be adjusted to different scenarios of an influenza epidemic.`
    ]
  };

  methods: CardContent = {
    title: 'Methods',
    sections: [
      `In collaboration with K-Projekt, who were in charge of the exhibition,
      we selected a choice of parameters and reduced the number of settings
      so that only the major experiments could be performed. We implemented
      a user interface that fitted the design of the planned exhibition and
      installed our simulator on a computer with touch display.`
    ]
  }

  insights: CardContent = {
    title: 'Insights',
    sections: [
      `The spread of an epidemic is not a linear process. As a result the
      outcomes of a simulation do not correlate in a linear way with the
      chosen interventions. To make this apparent even to not mathematically
      skilled persons it was our concern to deliver the simulator with an
      interactive user interface. Playing around with the parameter settings
      the users of our simulator could easily get an intuitive understanding
      of the forces that drive an epidemic.`
    ]
  };

  impact: CardContent = {
    title: 'Impact',
    sections: [
      `As a part of the „MenschMikrobe“ exhibition, that was on tour from
      2010 to 2014, our simulator was on display in fifteen cities all over
      Germany, Austria and Switzerland where it found general approval.`
    ]
  }




  constructor() { }

  ngOnInit(): void {
  }

}
